<template>
    <div>
        <section class="call-to-action call-to-action-default mb-0">
            <div class="container">
                <div class="row">
                    <div class="col-sm-9 col-lg-9">
                        <div class="call-to-action-content text-white">
                            <span v-if="$i18n.locale === 'es'">
                                <h3 class="text-white">Visita <span class="alternative-font">Arte-Contemporary</span>, una experiencia innovadora en el Delta del Ebro</h3>
                                <p class="mb-0 ">Aprovecha al máximo tu visita en La Ràpita!</p>
                            </span>
                            <span v-else-if="$i18n.locale === 'en'">
                                <h3>Visit <span class="alternative-font">Arte-Contemporary</span>, a day well spent in the Ebro Delta</h3>
                                <p class="mb-0">Make the most of your visit in La Ràpita!</p>
                            </span>
                            <span v-else-if="$i18n.locale === 'ca'">
                                <h3>Visita <span class="alternative-font">Arte-Contemporary</span>, una experiència innovadora al Delta de l’Ebre</h3>
                                <p class="mb-0">Treu el màxim profit de la teva visita a la Ràpita!</p>
                            </span>
                        </div>
                    </div>
                    <div class="col-sm-3 col-lg-3">
                        <div class="call-to-action-btn">
                            <router-link :to="{name:'bookingsFrontend'}" class="btn btn-modern text-2 btn-dark text-transform-none">{{ $t('hi.footer_call_action') }}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <footer id="footer" class="border-top-0 mt-0">
            <div class="bg-light footer-bottom-light-border">
                <div class="container py-5">
                    <div class="row justify-content-center text-center">
                        <div class="col-sm-3 text-center pt-3">
                            <a href="/" class="logo">
                                <img alt="Arte-contemporary" class="img-fluid" src="/frontend/img/logo-arte.png" width="226" height="100">
                            </a>
                        </div>
                        <div class="col-sm-3 text-center pt-5">
                            <a href="https://sculpture-network.org/en" target="_blank" rel="nofollow" title="sculpture network">
                                <img src="/images/logo_claim_en.jpg" class="img-fluid" alt="sculpture network">
                            </a>
                        </div>
                        <div class="col-sm-2 text-center pt-3">
                            <a href="https://www.galeriesdecatalunya.org/" title="Galeries d'art de catalunya" class="logo" target="_blank" rel="nofollow">
                                <img alt="Galeries d'art de catalunya" class="img-fluid"  src="/frontend/img/gac.jpeg" width="171" height="100">
                            </a>
                        </div>
                        <div class="col-sm-2 text-center pt-3">
                            <a href="https://www.collectiucultura.com/terresdelebre/" title="Col·lectiu Cultura" class="logo" target="_blank" rel="nofollow">
                                <img alt="Col·lectiu Cultura" class="img-fluid" src="/frontend/img/colectiu_cultura.jpeg" width="211" height="100">
                            </a>
                        </div>
                        <div class="col-sm-2 text-center pt-3">
                            <a href="https://enlarapita.com/" class="logo" title="Estació Nàutica la Ràpita">
                                <img alt="Estació Nàutica la Ràpita" class="img-fluid" src="/frontend/img/estacio_nautica.jpeg" width="331" height="100">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-bg-color-2 footer-bottom-light-border call-to-action call-to-action-default">
                <b-container>
                    <b-row>
                       <b-col sm="9" >
                           <div class="call-to-action-content">
                               <h3>{{ $t('hi.follow_instagram')}}</h3>
                           </div>
                       </b-col>
                        <b-col sm="3">
                            <div class="call-to-action-btn">
                                <a href="https://www.instagram.com/arte_contemporary" target="_blank" class="btn btn-primary btn-modern" rel="nofollow noopener">{{ $t('hi.view_profile')}}</a>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
            <div class="footer-bg-color-2 footer-bottom-light-border">
                <div class="container">"
                    <div class="row justify-content-center text-center py-5">
                        <div class="col-md-3 col-sm-6 text-center mb-4 mb-md-0">
                            <i class="fas fa-map-marker-alt text-9 text-color-light mb-3 mt-2"></i>
                            <p class="mb-0">
                                <strong class="text-color-light text-uppercase">{{ $t('hi.address') }}</strong>
                                <span class="d-block text-2 p-relative bottom-3"><a href="https://www.google.es/maps/dir//Arte-Contemporary/@40.6345891,0.5497333,13z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0x12a0fff96c6c5c01:0xaadf7892833b4c44!2m2!1d0.5847528!2d40.6345293" target="_blank" rel="noopener">{{ $t('hi.location') }}</a></span>
                            </p>
                        </div>
                        <div class="col-md-3 col-sm-6 text-center mb-4 mb-md-0">
                            <svg data-v-3e051f26="" xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#fff" viewBox="0 0 16 16" class="bi bi-whatsapp mt-2 mb-3"><path data-v-3e051f26="" d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"></path></svg>
                            <p class="mb-0">
                                <strong class="text-color-light text-uppercase">{{ $t('hi.whatsapp_contact') }}</strong>
                                <span class="d-block text-2 p-relative bottom-3"><a href="https://wa.me/+34645070012" rel="nofollow noopener">+34 645 070 012</a></span>
                            </p>
                        </div>
                        <div class="col-md-3 col-sm-6 text-center mb-4 mb-md-0">
                            <i class="far fa-clock text-9 text-color-light mb-3 mt-2"></i>
                            <p class="mb-0">
                                <strong class="text-color-light text-uppercase">{{ $t('hi.opening_times') }}</strong>
                                <span class="d-block text-2 p-relative bottom-3" v-html="$t('hi.opening_times_p')"></span>
                            </p>
                        </div>
                        <div class="col-md-3 col-sm-6 text-center">
                            <i class="fas fa-at text-9 text-color-light mb-3 mt-2"></i>
                            <p class="mb-0">
                                <strong class="text-color-light text-uppercase">{{ $t('hi.contactUs') }}</strong>
                                <span class="d-block text-2 p-relative bottom-3"><a href="mailto:info@arte-contemporary.eu" class="text-decoration-none">{{ $t('hi.info_mail') }}</a></span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-copyright">
                <div class="container py-2">
                    <div class="row py-4">
                        <div class="col-12 text-center">
                            <ul class="footer-social-icons social-icons social-icons-clean social-icons-icon-light mb-3">
                                <li class="social-icons-facebook"><a href="http://www.facebook.com/ArteContemporary" target="_blank" title="Facebook"><i class="fab fa-facebook-f text-2"></i></a></li>
                                <li class="social-icons-instagram"><a href="http://www.instagram.com/arte_contemporary" target="_blank" title="Instagram"><i class="fab fa-instagram text-2"></i></a></li>
                                <li class="social-icons-tripadvisor">
                                    <div id="TA_socialButtonBubbles636" class="TA_socialButtonBubbles">
                                        <ul id="qx4H2iww5" class="TA_links FmEdHVYP p-0">
                                            <li id="xzIiG43AqK9b" class="OdPdMHE">
                                                <a target="_blank" title="Tripadvisor" href="https://www.tripadvisor.es/Attraction_Review-g644333-d24084478-Reviews-Arte_contemporary_Sculpture_Park-Sant_Carles_de_la_Rapita_Terres_de_l_Ebre_Provi.html">
                                                    <img src="https://static.tacdn.com/img2/brand_refresh/Tripadvisor_logomark.svg" style="max-width: 30px;height: auto;filter: invert(100%);"/>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="col-auto m-auto">
                            <ul id="list-policies" class="col-auto">
                                <li><router-link :to="{name:'cookiesViewFrontend'}">{{ $t('hi.cookie_policy')}}</router-link></li>
                                <li><router-link :to="{name:'privacyPolicyViewFrontend'}">{{ $t('hi.privacy_policy')}}</router-link></li>
                                <li><router-link :to="{name:'legalPolicyViewFrontend'}">{{ $t('hi.legal_policy')}}</router-link></li>
                            </ul>
                        </div>
                        <div class="col-12 text-center">
                            <p>Raó social: Arte Contemporary Sant Carles de la Ràpita SL // CIF: B05395561</p>
                            <p>© Copyright {{ (new Date()).getFullYear() }}. {{ $t('hi.footerCopy') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script async
        src="https://www.jscache.com/wejs?wtype=socialButtonBubbles&amp;uniq=636&amp;locationId=24084478&amp;color=green&amp;size=rect&amp;lang=es&amp;display_version=2"
        data-loadtrk onLoad="this.loadtrk=true">
</script>
<script>function loadScript(a){var b=document.getElementsByTagName("head")[0],c=document.createElement("script");c.type="text/javascript",c.src="https://tracker.metricool.com/resources/be.js",c.onreadystatechange=a,c.onload=a,b.appendChild(c)}loadScript(function(){beTracker.t({hash:"f931d9aa40be22c8c0aadb24cb61cb5a"})});</script>
<script>
export default {
    name: "Footer",
    data(){
        return {
            suscribe: {
                email: '',
                name: '',
                cog:''
            }
        }
    },
    methods: {
        async suscibeSubmit(){
            await this.axios.post('/api/suscribe',this.suscribe)
                .then(response=>{
                    //swal suscribed success
                    this.$swal({
                        title: this.$t('hi.successfully_subscribed'),
                        icon: 'success',
                        timer:3000,
                        showCancelButton: false,
                        showCloseButton: false,
                        showConfirmButton: false
                    });
                })
                .catch(error=>{
                    //swal suscribed error
                    this.$swal({
                        title: this.$t('hi.error_subscribed'),
                        text: error.response.data.message,
                        icon: 'error',
                        timer: 3000,
                        showCancelButton: false,
                        showCloseButton: false,
                        showConfirmButton: false
                    })
                })
        }
    }
}
</script>

<style scoped>
#list-policies { list-style: none;margin: 0;padding: 0;}
#list-policies li {float: left}
#list-policies li:not(:first-of-type){padding-left: 5px;}
#list-policies li:not(:first-of-type)::before{content: "  /  ";}
/deep/ .call-to-action.call-to-action-default {background: #718189;}
/deep/ .call-to-action .call-to-action-content {text-align: left;}
/deep/ .call-to-action h3, /deep/ .call-to-action p, /deep/ .call-to-action .alternative-font {color: #fff;}
/deep/ .bottom--50{bottom:-50px;}
/deep/ .newsletter{padding-top:50px;padding-bottom:50px;color:#fff;}
/deep/ .newsletter .form-control::placeholder{color:#000}
/deep/ .newsletter .form-control::-ms-input-placeholder{color:#000}
</style>
